import React from "react";
import useAdminCustomersStats from "../hooks/useAdminCustomersStats";
import AdminCustomersStats from "../components/AdminCustomersStats";

const AdminCustomersStatsInterface = () => {
  const {
    periodType,
    startDate,
    endDate,
    stats,
    loading,
    handlePeriodTypeChange,
    handleStartDateChange,
    handleEndDateChange,
    handleApplyFilters,
    handleRefresh,
  } = useAdminCustomersStats();

  return (
    <AdminCustomersStats
      stats={stats}
      periodType={periodType}
      startDate={startDate}
      endDate={endDate}
      onPeriodTypeChange={handlePeriodTypeChange}
      onStartDateChange={handleStartDateChange}
      onEndDateChange={handleEndDateChange}
      onApplyFilters={handleApplyFilters}
      onRefreshData={handleRefresh}
      loading={loading}
    />
  );
};

export default AdminCustomersStatsInterface;
